<header class="header-wrapper pb-1 mb-4" [hidden]="!header">
  <style>
    /* Critical inline styles */
    .header-wrapper {
      background: linear-gradient(to right, #063e9a, #0d51c4);
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
    }
    .header-logo img {
      max-width: 100%;
      height: auto;
    }
    .fixed-top {
      background: linear-gradient(to right, #063e9a, #0d51c4);
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
    }
    .nav-link {
      color: #ffffff;
    }
    .app-buttons img {
      width: 120px;
      height: 33px;
    }
  </style>
  <div class="fixed-top">
    <div class="container-md head-bg-g">
      <div class="d-flex flex-wrap align-items-center justify-content-center justify-content-md-between py-3">
        <ul class="nav col col-lg-auto first-top-header d-block d-lg-none">
          <li class="d-block d-lg-none">
            <span class="nav-link link-light px-0 px-md-2">
              <button class="navbar-toggler x" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
            </span>
          </li>
        </ul>
        <ul class="nav col first-top-header d-none d-lg-flex">
          <li>
            <span class="nav-link text-center px-1 px-md-2 link-light" data-bs-toggle="modal" (click)="video = true"
              data-bs-target="#help_modal">
              <i class="fa fa-question-circle" aria-hidden="true"></i>
              <br />
              <small>Help</small>
            </span>
          </li>
          <li>
            <span *ngIf="_common.isBrowser" class="nav-link px-1 px-md-2 link-light text-center"
              (click)="getNotifications()" [attr.data-bs-toggle]="(_user.authState | async) && 'modal'"
              [attr.data-bs-target]="
                (_user.authState | async) && '#notification_modal'
              ">
              <i class="fa fa-bell"></i>
              <br />
              <small>Notifications</small>
            </span>
          </li>
          <li *ngIf="_user.authUser | async as user">
            <a [routerLink]="['/', user | UserSlug, 'profile', 'statistics']"
              class="nav-link px-1 text-center px-md-2 link-light">
              <i class="fas fa-chart-pie text-f16"></i>
              <br /><small>My Stats</small>
            </a>
          </li>
        </ul>

        <a routerLink="/"
          class="d-flex col-auto align-items-center mb-2 mb-md-0 text-dark text-decoration-none header-logo">
          <img webpimage src="assets/img/kingpin-logo-white.png" alt="logo" class="img-fluid" width="92" height="86" />
        </a>

        <ul class="nav justify-content-end col">
          <div class="app-buttons">
            <!-- iOS App Button -->
            <a
              title="Kingpin Sports Picks App"
              href="https://kingpin.pro/ios"
              target="_blank"
              rel="noopener"
              class="mx-2"
            >
              <img
                src="assets/img/button-5.jpg"
                alt="Kingpin Sports Picks App"
                width="120"
                height="33"
                loading="lazy"
              />
            </a>
          </div>
          <ng-container *ngIf="!(_user.authState | async); else loggedIn">
            <li>
              <a [routerLink]="['/auth/login']" (click)="redirectLogin()"
                class="nav-link px-1 px-md-2 link-light login-signup text-end">Login / Register</a>
            </li>
          </ng-container>
          <ng-template #loggedIn>
            <li class="me-3 dropdown d-none d-lg-block">
              <span class="nav-link px-1 text-center px-md-2 link-light" data-bs-toggle="dropdown"
                data-bs-auto-close="outside">
                <span [attr.data-count]="(_sport.pickslip | async)?.length" class="pickslip">
                  <i class="fas fa-shopping-cart" style="font-size: 18px"></i>
                </span>
                <br /><small>Pick Slip</small>
              </span>
              <div class="dropdown-menu dropdown-menu-end py-0 cart-header-dropdown rounded-10 shadow overflow-hidden"
                aria-labelledby="dropdownMenuClickableInside">
                <div class="auto-scroll">
                  <app-pick-slip></app-pick-slip>
                </div>
              </div>
            </li>
            <li *ngIf="_user.authUser | async as user" class="list-inline-item p-0 me-3">
              <div class="btn-group">
                <div class="header-profile">
                  <a [routerLink]="['/profile']">
                    <img src="{{ user.user_avatar | baseUrl }}" alt="user" class="profile-img d-block mx-auto" /><small
                      class="text-white">My Profile</small></a>
                </div>
              </div>
            </li>
            <li class="d-none d-lg-block">
              <span class="text-center nav-link px-1 px-md-2 link-light login-signup" (click)="logout()"><i
                  class="fas fa-sign-out-alt text-white ml-3"></i> <br />
                <small>Logout</small></span>
            </li>
          </ng-template>
        </ul>
      </div>

      <div class="row mx-0">
        <ul class="nav col first-top-header d-flax d-lg-none">
          <li>
            <span class="nav-link text-center px-1 px-md-2 link-light" data-bs-toggle="modal" (click)="video = true"
              data-bs-target="#help_modal">
              <i class="fa fa-question-circle" aria-hidden="true"></i>
              <br />
              <small>Help</small>
            </span>
          </li>
          <li>
            <span class="nav-link px-1 px-md-2 link-light text-center" (click)="getNotifications()"
              [attr.data-bs-toggle]="(_user.authState | async) && 'modal'" [attr.data-bs-target]="
                (_user.authState | async) && '#notification_modal'
              ">
              <i class="fa fa-bell" aria-hidden="true"></i>

              <br />
              <small>Notifications</small>
            </span>
          </li>
          <li *ngIf="_common.isBrowser && _user.authUser | async as user">
            <a [routerLink]="['/', user | UserSlug, 'profile', 'statistics']"
              class="nav-link px-1 text-center px-md-2 link-light">
              <i class="fas fa-chart-pie text-f16"></i>
              <br /><small>My Stats</small>
            </a>
          </li>
        </ul>
        <ul class="nav justify-content-end col-auto">
          <li class="me-3 dropdown d-block d-lg-none">
            <span class="nav-link px-1 text-center px-md-2 link-light" data-bs-toggle="dropdown"
              data-bs-auto-close="outside">
              <span [attr.data-count]="(_sport.pickslip | async)?.length" class="pickslip">
                <i class="fas fa-shopping-cart" style="font-size: 18px"></i>
              </span>
              <br /><small>Pick Slip</small>
            </span>
            <div class="dropdown-menu dropdown-menu-end py-0 cart-header-dropdown rounded-10 shadow overflow-hidden"
              aria-labelledby="dropdownMenuClickableInside">
              <div class="auto-scroll">
                <app-pick-slip></app-pick-slip>
              </div>
            </div>
          </li>

          <li class="d-block d-lg-none" *ngIf="_user.authState | async">
            <span class="text-center nav-link px-1 px-md-2 link-light login-signup" (click)="logout()"><i
                class="fas fa-sign-out-alt text-white ml-3"></i> <br />
              <small>Logout</small></span>
          </li>
        </ul>
      </div>
    </div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-transparent menu-nav py-0">
      <div class="container-fluid">
        <div class="collapse navbar-collapse justify-content-center py-2" id="navbarNavDropdown">
          <ul class="navbar-nav">
            <ng-container *ngFor="let menu of menus">
              <li class="nav-item px-xl-2 px-xxl-3">
                <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
                  *ngIf="menu.type == 'internal'; else other" routerLinkActive="active" [routerLink]="[menu.link]"
                  [routerLinkActiveOptions]="{ exact: true }">{{ menu.title }}</a>
                <ng-template #other>
                  <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" target="_blank"
                    [href]="menu.link" *ngIf="menu.type == 'external'; else modal">{{ menu.title }}</a>
                  <ng-template #modal>
                    <span class="nav-link" data-bs-toggle="modal" data-bs-target="#appusemodal"
                      (click)="_common.getOS(true)">{{ menu.title }}</span>
                  </ng-template>
                </ng-template>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </nav>
  </div>

  <app-live-scores *ngIf="_common.isBrowser"></app-live-scores>
  <app-sports></app-sports>
</header>
<div class="modal fade" id="notification_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-10 positio-relative">
      <div class="modal-header">
        <h6 class="modal-title fw-bold">
          Notification
          <img src="assets/icons/notificatio-bell.svg" alt="notifications" class="img-fluid" />
        </h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body z-index-1" style="max-height: 450px; overflow: auto">
        <!-- tabs section start -->
        <ul class="list-inline filter-tabs-area py-3 text-center" role="tablist">
          <li class="list-inline-item" role="presentation">
            <button [class.active]="notifications" (click)="notifications = true">All Notifications</button>
          </li>
          <li class="list-inline-item" role="presentation">
            <button [class.active]="!notifications" (click)="notifications = false">Pause Notifications</button>
          </li>
        </ul>
        <!-- tabs section end -->
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade" [ngClass]="{ 'show active': notifications }" [hidden]="!notifications">
            <div class="row mb-3 gx-3" *ngFor="let item of notificationData">
              <div class="col-auto align-self-center mb-2">
                <span class="bg-light rounded-10 p-2">
                  <img src="assets/icons/notificatio-bell.svg" alt="notification" class="img-fluid" />
                </span>
              </div>
              <div class="col border-bottom pb-2 border-light">
                <a [routerLink]="
                    item.type == 'follow'
                      ? [
                          '/',
                          item | UserSlug: item.from_user,
                          'profile',
                          'statistics'
                        ]
                      : item.type == 'pick'
                      ? [
                          '/',
                          item | UserSlug: item.from_user,
                          'profile',
                          'upcoming-picks'
                        ]
                      : ['/', 'chat', 'latest', item.record_id]
                  " data-bs-dismiss="modal">
                  <h6 class="mb-0 text-dark">
                    {{ item.title }}
                  </h6>
                  <p class="text-muted small mb-0">
                    {{ item.message }}
                  </p>
                </a>
              </div>
              <div class="col-auto small border-bottom pb-2 border-light" *ngIf="_common.isBrowser">
                {{ item.created_at + " UTC" | duration | async }}
              </div>
            </div>
            <div class="row mb-3 gx-3" *ngIf="notificationData && !notificationData?.length">
              <div class="col-auto align-self-center mb-2 text-center">
                No Notifications
              </div>
            </div>
            <div class="row mb-3 gx-3" *ngIf="!notificationData">
              <div class="col-auto align-self-center mb-2 text-center">
                loading...
              </div>
            </div>
          </div>
          <div class="tab-pane fade" [ngClass]="{ 'show active': !notifications }" [hidden]="notifications">
            <h5 class="fw-bolder mb-3 text-muted mb-4">Push Notifications</h5>
            <form [formGroup]="notificationForm">
              <div class="px-2">
                <div class="row mb-3 gx-3">
                  <div class="col-auto">
                    <img src="assets/icons/like-icon.svg" alt="like" class="img-fluid" />
                  </div>
                  <div class="col border-bottom pb-3 border-light">
                    Like Notification
                  </div>
                  <div class="col-auto small border-bottom pb-3 border-light">
                    <label class="switch mt-1" for="like_notification_checkbox"
                      *ngIf="notificationForm.get('like_notify') as control">
                      <input type="checkbox" id="like_notification_checkbox" [formControl]="control"
                        class="switch-checkbox" (change)="
                          control.setValue(control.value ? 1 : 0);
                          updateNotification()
                        " />
                      <div class="switch-slider round"></div>
                    </label>
                  </div>
                </div>
                <div class="row mb-3 gx-3">
                  <div class="col-auto">
                    <img src="assets/icons/reply-icon2.svg" alt="follow" class="img-fluid" />
                  </div>
                  <div class="col border-bottom pb-3 border-light">
                    Reply Notification
                  </div>
                  <div class="col-auto small border-bottom pb-3 border-light">
                    <label class="switch mt-1" for="reply_notification_checkbox"
                      *ngIf="notificationForm.get('reply_notify') as control">
                      <input type="checkbox" id="reply_notification_checkbox" class="switch-checkbox"
                        [formControl]="control" (change)="
                          control.setValue(control.value ? 1 : 0);
                          updateNotification()
                        " />
                      <div class="switch-slider round"></div>
                    </label>
                  </div>
                </div>
                <div class="row mb-3 gx-3">
                  <div class="col-auto">
                    <img src="assets/icons/follow-icon.svg" alt="notification" class="img-fluid" />
                  </div>
                  <div class="col">Follow Notification</div>
                  <div class="col-auto small">
                    <label class="switch mt-1" for="follow_notification_checkbox"
                      *ngIf="notificationForm.get('follow_notify') as control">
                      <input type="checkbox" id="follow_notification_checkbox"
                        class="switch-checkbox {{ control.value }}" [formControl]="control" (change)="
                          control.setValue(control.value ? 1 : 0);
                          updateNotification()
                        " />
                      <div class="switch-slider round"></div>
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <img src="assets/img/modal-botton-design.png" alt="modal botton design" class="modal-botton-design" />
    </div>
  </div>
</div>
<!-- Notification popup close -->
<!-- Help popup start -->
<!-- Modal -->
<div class="modal fade" id="help_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-10 positio-relative">
      <div class="modal-header">
        <h6 class="modal-title fw-bold">
          Expert picks Help
          <img src="assets/icons/help-icon-dark.svg" alt="Help" class="img-fluid" />
        </h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body z-index-1">
        <p>View upcoming picks by sport and game</p>
        <p>Picks sorted by top cappers by sport</p>
        <p>
          View the Sharp Pick, using our proprietary algorithm, and the
          Consensus Pick
        </p>
        <div class="help-video-frame">
          <iframe *ngIf="video" class="rounded-10" width="100%" height="345"
            src="https://www.youtube.com/embed/2NdWCIb8DTo">
          </iframe>
        </div>
      </div>
      <img src="assets/img/modal-botton-design.png" alt="modal botton design" class="modal-botton-design" />
    </div>
  </div>
</div>
<!-- Help popup close -->
